// extracted by mini-css-extract-plugin
module.exports = {"root":"OssLicense_root__28UFu","title":"OssLicense_title__ochzd","name":"OssLicense_name__1R8Rn","text":"OssLicense_text__2Qq4F"};